import { useNonFavouritedSportsBooks } from './useNonFavouritedSportsBooks';

export const useNonFavouritedSportsBookCount = () => {
  return useNonFavouritedSportsBooks().length;
};
